import React, { useState, useEffect } from 'react';
import '../Admin.css'; // Import CSS for styling
import { useNavigate, Link, useLocation } from 'react-router-dom';
import { registerData, getAllDataWithFlag, updatecmsUser } from '../../../services/CommonService';
import { useAuth } from '../../../Utils/AuthProvider'
import { Modal, Button, Form, Row, Col, Container } from 'react-bootstrap';
import Swal from 'sweetalert2';

function SignUp() {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [role, setRole] = useState("");
  const [status, setStatus] = useState(0);
  const navigate = useNavigate();
  const { setAuthToken } = useAuth();
  const [RoleData, setRoleData] = useState([]);
  const [StatusData, setStatusData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [password, setPassword] = useState('');
  const [passwordError, setPasswordError] = useState('');
  const location = useLocation();
  const userDatafromlist = location.state?.userData;

  useEffect(() => {
    const typologyDa = JSON.parse(localStorage.getItem('roledata'));
    setRoleData(typologyDa?.filter((m)=> m?.name !== "Super Admin"))
    if (userDatafromlist) {
      // Set form state or do something with userData
      setName(userDatafromlist.name || '');
      setEmail(userDatafromlist.email || '');
      setPassword(userDatafromlist.password || '');
      setRole(userDatafromlist.role || '');
      setStatus(userDatafromlist.is_deleted ?? '');
    }
  }, [userDatafromlist]);

  const handleRoleChange = (e) => {
    setRole(e.target.value);
  };

  const handleStatusChange = (e) => {
    setStatus(Number(e.target.value));
  };

  const handleBack = () => {
    navigate(-1);
  };

  const handleNameChange = (event) => {
    const inputValue = event.target.value;
    const isValid = /^[A-Za-z\s]*$/.test(inputValue);
    if (isValid && inputValue.length <= 40) {
      setName(inputValue);
    }
  };

  const handleEmailChange = (event) => {
    setEmail(event.target.value);
  };

  const handlePasswordChange = (event) => {
    const val = event.target.value;
    setPassword(val);
    const passwordRegex = /^(?=.*[0-9])(?=.*[!@#$%^&*])[A-Za-z0-9!@#$%^&*]{6,20}$/;
    if (!passwordRegex.test(val)) {
      setPasswordError(
        'Password must be 6–20 characters, include at least 1 number and 1 special character.'
      );
    } else {
      setPasswordError('');
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError('');
    try {
      if (!userDatafromlist) {
        let userData = {
          name: name,
          email: email,
          password: password,
          role: role,
          is_deleted: status
        }
        const response = await registerData(userData);
        const data = response.data; // axios automatically parses JSON
        if (response.status === 200) { // Check for successful status code
          const mstlookup = await getAllDataWithFlag(3);
          const master = await getAllDataWithFlag(11);
          localStorage.setItem('lookup', JSON.stringify(mstlookup?.data?.mstlookup));
          localStorage.setItem('StateMaster', JSON.stringify(master?.data));
          Swal.fire({
            title: "Success!",
            text: "Registration successful!",
            icon: "success",
            confirmButtonText: "OK",
            allowOutsideClick:false
          }).then((m) => {
            if (m.isConfirmed) {
              handleBack();
            }
          })
        } else {
          setError(data.message || 'Invalid username or password.');
        }
      } else {
        const response = await updatecmsUser({
          name: name,
          email: email,
          password: password,
          role: role,
          email_verified_at: 'null',
          created_at: new Date(),
          updated_at: new Date(),
          is_deleted: status
        }, userDatafromlist.id);
        if (response.status == 200) {
          Swal.fire({
            title: "Success!",
            text: "User updated successfully!",
            icon: "success",
            confirmButtonText: "OK",
          });
        } else {
          Swal.fire({
            title: "error!",
            text: '',
            icon: "error",
            confirmButtonText: "OK",
          });
        }
      }
    } catch (error) {
      setError('Failed to connect to the server.');
      if (error.response && error.response.data && error.response.data.message) {
        setError(error.response.data.message); // Display server-specific error
      }
    }
  };

  return (
    <div
      style={{
        maxWidth: '400px',
        margin: '20px auto',
        borderRadius: '12px',
        boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
        fontFamily: 'Segoe UI, sans-serif',
        overflow: 'hidden', // Ensures rounded corners include the header
      }}
    >
      {/* Blue Header */}

      <div
        style={{
          backgroundColor: '#28186f',
          color: 'white',
          padding: '4px 10px',
          fontSize: '20px',
          fontWeight: 'bold',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <span>{!userDatafromlist ? 'Admin Registration' : 'Admin Update'}</span>
        <button className="btn btn-sm btn-warning" onClick={handleBack}>
          <i className="fas fa-arrow-left"></i> Back
        </button>
      </div>

      {/* Form Container */}
      <div
        style={{
          backgroundColor: '#ffffff',
          padding: '15px',
        }}
      >
        {error && (
          <p
            style={{
              color: '#d9534f',
              backgroundColor: '#f9d6d5',
              padding: '10px',
              borderRadius: '6px',
              textAlign: 'center',
            }}
          >
            {error}
          </p>
        )}

        <form onSubmit={handleSubmit}>
          {/* Name */}
          <div className="form-group-regi" style={{ marginBottom: '15px' }}>
            <label htmlFor="name" style={{ display: 'block', marginBottom: '5px', fontWeight: '600' }}>
              Name<span className="text-danger">*</span>
            </label>
            <input
              type="text"
              id="name"
              placeholder="Name"
              value={name}
              onChange={handleNameChange}
              minLength={3}
              maxLength={40}
              required
              style={{
                width: '100%',
                padding: '10px',
                borderRadius: '6px',
                border: '1px solid #ccc',
                fontSize: '14px',
              }}
            />
          </div>

          {/* Email */}
          <div className="form-group" style={{ marginBottom: '15px' }}>
            <label htmlFor="email" style={{ display: 'block', marginBottom: '5px', fontWeight: '600' }}>
              Email<span className="text-danger">*</span>
            </label>
            <input
              type="email"
              id="email"
              placeholder="Email"
              value={email}
              onChange={handleEmailChange}
              required
              style={{
                width: '100%',
                padding: '10px',
                borderRadius: '6px',
                border: '1px solid #ccc',
                fontSize: '14px',
              }}
            />
          </div>

          {!userDatafromlist && (
            <div className="form-group" style={{ marginBottom: '20px', position: 'relative' }}>
              <label htmlFor="password" style={{ display: 'block', marginBottom: '5px', fontWeight: '600' }}>
                Password<span className="text-danger">*</span>
              </label>
              <input
                type={showPassword ? 'text' : 'password'}
                id="password"
                placeholder="Password"
                value={password}
                onChange={handlePasswordChange}
                minLength={6}
                maxLength={20}
                required
                style={{
                  width: '100%',
                  padding: '10px 40px 10px 10px',
                  borderRadius: '6px',
                  border: '1px solid #ccc',
                  fontSize: '14px',
                }}
              />
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                style={{
                  position: 'absolute',
                  top: '38px',
                  right: '10px',
                  background: 'none',
                  border: 'none',
                  cursor: 'pointer',
                  color: '#888',
                }}
              >
                <i className={`bi ${showPassword ? 'bi-eye-slash' : 'bi-eye'}`}></i>
              </button>
              {passwordError && (
                <div style={{ color: 'red', fontSize: '12px' }}>{passwordError}</div>
              )}
            </div>
          )}
          <div className="form-group" style={{ marginBottom: '15px' }}>
            <label
              htmlFor="role"
              style={{ display: 'block', marginBottom: '5px', fontWeight: '600' }}
            >
              Role<span className="text-danger">*</span>
            </label>
            <select
              id="role"
              value={role}
              onChange={handleRoleChange}
              required
              style={{
                width: '100%',
                padding: '10px',
                borderRadius: '6px',
                border: '1px solid #ccc',
                fontSize: '14px',
              }}
            >
              <option value="">Select Role</option>
              {RoleData.filter(item => item.name !== 'Admin').map((item) => (
                <option key={item.id} value={item.id}>
                  {item.name}
                </option>
              ))}
            </select>
          </div>
          <div className="form-group" style={{ marginBottom: '15px' }}>
            <label
              htmlFor="status"
              style={{ display: 'block', marginBottom: '5px', fontWeight: '600' }}
            >
              Status<span className="text-danger">*</span>
            </label>
            <select
              id="status"
              value={status}
              onChange={handleStatusChange}
              required
              style={{
                width: '100%',
                padding: '10px',
                borderRadius: '6px',
                border: '1px solid #ccc',
                fontSize: '14px',
              }}
            >
              <option value="">Select Status</option>
              <option key={0} value={0}>
                {'Active'}
              </option>
              <option key={1} value={1}>
                {'Inactive'}
              </option>
            </select>
          </div>
          <button
            type="submit"
            className="btn btn-warning w-100 ">
            {!userDatafromlist ? 'Register' : 'Update'}
          </button>
        </form>
      </div>
    </div>
  );
}

export default SignUp;